module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container py-5",
    staticStyle: {
      "max-width": "800px",
      "margin": "auto"
    }
  }, [_c('h1', {
    staticClass: "mb-4"
  }, [_vm._v("Política de Privacidade")]), _vm._v(" "), _c('p', [_vm._v("\n      A "), _c('span', {
    staticClass: "pp-strong"
  }, [_vm._v("ATENTO")]), _vm._v(", responsável pela operação do sistema hospedado em\n      "), _c('a', {
    staticClass: "pp-link",
    attrs: {
      "href": "https://www1.softwareatento.com.br",
      "target": "_blank"
    }
  }, [_vm._v("https://www1.softwareatento.com.br")]), _vm._v(",\n      reconhece a importância da privacidade e da proteção de dados pessoais. Esta Política de Privacidade estabelece de forma clara e transparente como tratamos os dados coletados,\n      em especial os dados oriundos de integrações com serviços do Google via OAuth 2.0, em conformidade com a "), _c('span', {
    staticClass: "pp-strong"
  }, [_vm._v("LGPD")]), _vm._v(",\n      as Políticas de Privacidade da Google e demais legislações aplicáveis.\n  ")]), _vm._v(" "), _c('h2', {
    staticClass: "pp-subtitle"
  }, [_vm._v("1. Finalidade do Sistema")]), _vm._v(" "), _c('p', {
    staticClass: "pp-paragraph"
  }, [_vm._v("\n    O Software Atento é uma plataforma de gestão voltada para clínicas e profissionais da área de "), _c('span', {
    staticClass: "pp-strong"
  }, [_vm._v("Medicina do Trabalho")]), _vm._v(", com funcionalidades como:\n  ")]), _vm._v(" "), _c('ul', {
    staticClass: "pp-list"
  }, [_c('li', [_vm._v("Agendamento de consultas e exames")]), _vm._v(" "), _c('li', [_vm._v("Emissão de laudos médicos")]), _vm._v(" "), _c('li', [_vm._v("Envio automatizado de comunicados, boletos e documentos")]), _vm._v(" "), _c('li', [_vm._v("Gestão de prontuários ocupacionais")]), _vm._v(" "), _c('li', [_vm._v("Integração com sistemas do eSocial")])]), _vm._v(" "), _c('h2', {
    staticClass: "pp-subtitle"
  }, [_vm._v("2. Dados Coletados")]), _vm._v(" "), _c('h3', {
    staticClass: "pp-subtitle"
  }, [_vm._v("2.1 Dados fornecidos pelo usuário:")]), _vm._v(" "), _c('ul', {
    staticClass: "pp-list"
  }, [_c('li', [_vm._v("Nome completo")]), _vm._v(" "), _c('li', [_vm._v("Endereço de e-mail")]), _vm._v(" "), _c('li', [_vm._v("Cargo ou função")]), _vm._v(" "), _c('li', [_vm._v("Nome da clínica ou empresa")]), _vm._v(" "), _c('li', [_vm._v("Dados de login")])]), _vm._v(" "), _c('h3', {
    staticClass: "pp-subtitle"
  }, [_vm._v("2.2 Dados de autenticação via Google (OAuth2):")]), _vm._v(" "), _c('p', {
    staticClass: "pp-paragraph"
  }, [_vm._v("\n    Ao autorizar o uso de funcionalidades do Google, coletamos os seguintes dados:\n  ")]), _vm._v(" "), _c('ul', {
    staticClass: "pp-list"
  }, [_c('li', [_vm._v("Token de acesso temporário (OAuth2)")]), _vm._v(" "), _c('li', [_vm._v("Endereço de e-mail autenticado")]), _vm._v(" "), _c('li', [_vm._v("Permissão para envio de e-mails via Gmail ("), _c('code', [_vm._v("https://www.googleapis.com/auth/gmail.send")]), _vm._v(")")])]), _vm._v(" "), _c('h2', {
    staticClass: "pp-subtitle"
  }, [_vm._v("3. Uso dos Dados")]), _vm._v(" "), _c('p', {
    staticClass: "pp-paragraph"
  }, [_vm._v("\n    Os dados são utilizados exclusivamente para autenticação, envio de laudos e comunicação clínica. Não são usados para publicidade ou fins analíticos externos.\n  ")]), _vm._v(" "), _c('h2', {
    staticClass: "pp-subtitle"
  }, [_vm._v("4. Compartilhamento e Divulgação")]), _vm._v(" "), _c('p', {
    staticClass: "pp-paragraph"
  }, [_vm._v("\n    Os dados não são vendidos, alugados ou compartilhados com terceiros, exceto em casos exigidos por lei ou mediante ordem judicial.\n  ")]), _vm._v(" "), _c('h2', {
    staticClass: "pp-subtitle"
  }, [_vm._v("5. Retenção e Exclusão de Dados")]), _vm._v(" "), _c('p', {
    staticClass: "pp-paragraph"
  }, [_vm._v("\n    Os dados são mantidos apenas enquanto forem necessários para os fins descritos. O usuário pode solicitar exclusão total a qualquer momento pelo e-mail:\n    "), _c('a', {
    staticClass: "pp-link",
    attrs: {
      "href": "mailto:suporte@softwareatento.com.br"
    }
  }, [_vm._v("suporte@softwareatento.com.br")]), _vm._v(".\n  ")]), _vm._v(" "), _c('h2', {
    staticClass: "pp-subtitle"
  }, [_vm._v("6. Segurança da Informação")]), _vm._v(" "), _c('ul', {
    staticClass: "pp-list"
  }, [_c('li', [_vm._v("Conexões criptografadas (HTTPS/TLS)")]), _vm._v(" "), _c('li', [_vm._v("Armazenamento seguro de tokens")]), _vm._v(" "), _c('li', [_vm._v("Autenticação baseada em permissões")]), _vm._v(" "), _c('li', [_vm._v("Auditorias de segurança regulares")])]), _vm._v(" "), _c('h2', {
    staticClass: "pp-subtitle"
  }, [_vm._v("7. Direitos do Usuário (LGPD)")]), _vm._v(" "), _c('p', {
    staticClass: "pp-paragraph"
  }, [_vm._v("Os usuários têm direito a:")]), _vm._v(" "), _c('ul', {
    staticClass: "pp-list"
  }, [_c('li', [_vm._v("Acesso, correção e exclusão de dados")]), _vm._v(" "), _c('li', [_vm._v("Informações sobre o tratamento e compartilhamento")]), _vm._v(" "), _c('li', [_vm._v("Portabilidade e revogação de consentimento")])]), _vm._v(" "), _c('h2', {
    staticClass: "pp-subtitle"
  }, [_vm._v("8. Uso de Cookies")]), _vm._v(" "), _c('p', {
    staticClass: "pp-paragraph"
  }, [_vm._v("\n    Utilizamos cookies para autenticação de sessão e estatísticas internas. O usuário pode desativar cookies pelo navegador.\n  ")]), _vm._v(" "), _c('h2', {
    staticClass: "pp-subtitle"
  }, [_vm._v("9. Alterações nesta Política")]), _vm._v(" "), _c('p', {
    staticClass: "pp-paragraph"
  }, [_vm._v("\n    Podemos atualizar esta política a qualquer momento. Alterações significativas serão destacadas na plataforma.\n  ")]), _vm._v(" "), _c('h2', {
    staticClass: "pp-subtitle"
  }, [_vm._v("10. Contato")]), _vm._v(" "), _c('p', {
    staticClass: "pp-paragraph"
  }, [_vm._v("\n    Dúvidas ou solicitações podem ser enviadas para:\n  ")]), _vm._v(" "), _c('ul', {
    staticClass: "pp-list"
  }, [_c('li', [_vm._v("E-mail: "), _c('a', {
    staticClass: "pp-link",
    attrs: {
      "href": "mailto:suporte@softwareatento.com.br"
    }
  }, [_vm._v("suporte@softwareatento.com.br")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42d0de29"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/Privacy-Policy/index.vue
// module id = 1493
// module chunks = 45